import { Col, Row } from 'react-bootstrap'
import styles from './Log.module.css'
import { DateTime } from "luxon"
import TokenModal from '../logs-list/TokenModal'
import { useState } from 'react'

export enum VPN_LOGIN_STATUS {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE"
}

type VpnUserLogin = {
    username: string
}

export type VpnLoginType = {
    id: number
    ipAddress: string
    status: VPN_LOGIN_STATUS
    generatedToken: string
    loginAt: string
    logoutAt: string | null
    user: VpnUserLogin
}

interface loginPropsInterface {
    odd: boolean
    log: VpnLoginType
}

function formatDate(dateValue: string | null) {
    if(dateValue === null) {
        return ''
    }

    return DateTime.fromMillis(Number(dateValue), { zone: "utc" })
        .setZone("Europe/Budapest")
        .toFormat("yyyy.MM.dd HH:mm")
}

function formatDuration(loginAt: string, logoutAt: string | null): string {
    if (!loginAt || !logoutAt) return '-'

    const start = Number(loginAt)
    const end = Number(logoutAt)

    if (isNaN(start) || isNaN(end) || end < start) return '-'

    const durationMs = end - start
    const totalMinutes = Math.floor(durationMs / 1000 / 60)
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    return `${hours !== 0 ? hours + ' óra' : ''} ${minutes} perc`
}

export default function Log({ odd, log }:loginPropsInterface) {
    const loginDate = formatDate(log.loginAt)
    const logoutDate = formatDate(log.logoutAt)
    const duration = logoutDate !== '' ? formatDuration(log.loginAt, log.logoutAt) : formatDuration(log.loginAt, Date.now().toString())
    const [ showTokenModal, setShowTokenModal ] = useState(false)

    return(
        <>
            <Row style={odd ? {backgroundColor: "rgb(0, 0, 0, 0.1)"} : {backgroundColor: "rgb(0, 0, 0, 0.3)"} } className={styles.containerBody}>

                <Col sm="1">{log.id}</Col>

                <Col sm="2">{log.user.username}</Col>

                <Col sm="1">{log.ipAddress}</Col>

                <Col sm="2">{loginDate}</Col>

                <Col sm="2">{logoutDate}</Col>

                <Col sm="1">{duration}</Col>

                <Col sm="1">
                    <img onClick={() => setShowTokenModal(true)} src="/token_szines.png" className={ styles.token } alt="token" title="token" />
                </Col>

                <Col sm="2">
                    {
                        log.status === "ACTIVE"
                        ?
                        <img src="/vpn_active.png" className={ styles.vpnImg } alt="Aktív" title="Aktív" />
                        :
                        <img src="/vpn_inactive.png" className={ styles.vpnImg } alt="Inaktív" title="Inaktív" />
                    }
                </Col>
            </Row>

            <TokenModal
                visible={showTokenModal}
                onHide={() => setShowTokenModal(false)}
                token={log.generatedToken}
            />
        </>
    )
}